import { api } from "services/api"
import ErrorHandler from "./ErrorHandler"
import { apiWithEncryption } from "context/queryEncrypted"

interface AccountsPayload extends App.AccountsQueryParams {
  skip: number
  take: number
}

class ApiAccounts extends ErrorHandler {
  async searchAccounts(params: AccountsPayload) {
    return api.get("/account/list", {
      params
    })
  }

  async updateBalance(data: App.AccountUpdateBalancePayload) {
    return api.patch("/account/balance", data)
  }

  async patch(data: App.AccountPatchPayload, id: string) {
    return api.patch(`/account/patch/${id}`, data)
  }

  async updateFreeTrial(data: App.AccountUpdateFreeTrialPayload) {
    return api.patch("/account/freeTrial", data)
  }

  async getFirstSteps() {
    const response = await api.get<App.FirstStepsStatus>("/account/first-steps")

    return {
      hasProduct: response.data.hasProduct,
      hasEventType: response.data.hasEventType,
      hasPurchasePlan: response.data.hasPurchasePlan
    }
  }

  async getSystemEventByAccountId(id: string) {
    const data = await api.get(`/account/events/${id}`)

    return data.data
  }

  async updateProfileName(data: App.AccountUpdateProfileNamePayload) {
    const response = await apiWithEncryption.patch("/account/update-name", data)

    return response
  }

  async updateProfilePassword(data: App.AccountUpdateProfilePasswordPayload) {
    const response = await apiWithEncryption.patch("/account/update-password", data)

    return response
  }

  async pathBlockAccountEnterpriseAndPayByInvoice(id: string, data: App.AccountBlockEnterprisePayload) {
    const response = await api.patch(`/account/block-account-enterprise/${id}`, data)

    return response
  }

  async pathActiveAccountEnterpriseAndPayByInvoice(id: string, data: App.AccountActiveEnterprisePayload) {
    const response = await api.patch(`/account/active-account-enterprise/${id}`, data)

    return response
  }

  async getAccountBalanceDetails(params: App.AccountBalancePayload) {
    if (!params.accountId) return

    return api.get("/account/balance", {
      params
    })
  }

  async getAccountBillings(params: App.AccountBillingsPayload) {
    if (!params.accountId) return

    return api.get("/account/billings", {
      params
    })
  }

  async getAccountEvents(params: App.AccountEventsPayload) {
    if (!params.accountId || !params.date) return

    return api.get("/account/events-chart", {
      params
    })
  }
}

export default ApiAccounts
